import React from "react";

const JideOyelayo: React.FC = () => {
  return (
    <small className="d-block text-center text-gray-500">
      Design &amp; build by{" "}
      <a
        href="https://me.jideoyelayo.com"
        className="text-reset text-decoration-none"
        rel="noopener"
      >
        Me
      </a>
      <span className="mx-1" aria-hidden="true">·</span>
      <a
        href="mailto:jideoyelayo1@mail.com?subject=Website%20enquiry"
        className="text-reset text-decoration-none"
      >
        Contact
      </a>
    </small>
  );
};

export default JideOyelayo;
